import React from 'react';
import { ErrorData } from 'new/elements/ErrorData';

interface ResourceErrorDataProps {
  data?: any;
  resourceType: string;
}

export const ResourceErrorData = (props: ResourceErrorDataProps) => {
  const { data, resourceType } = props;
  return <ErrorData resourceType={resourceType} resourceId={data.id} />;
};

export default ResourceErrorData;
